<div class="modal-header">
    <h2 class="modal-title">Detail</h2>
</div>
<div class="flex-fill d-flex flex-column">
    <div class="card">
        <div class="card-body">
            <div class="m-1 grid-fill" [ngStyle]="{ height: '100%' }" style="min-height: 300px">
                <dx-data-grid
                    [dataSource]="entities"
                    keyExpr="id"
                    [cacheEnabled]="false"
                    (onRowUpdated)="save(false, $event)"
                    (onRowRemoving)="deleteRow($event)"
                    (onRowPrepared)="onRowPrepared($event)"
                >
                    <dxi-column dataField="job.jobNumber" caption="Job #" width="100" [allowEditing]="false"> </dxi-column>
                    <dxi-column dataField="employee.displayName" caption="Employee" width="125" [allowEditing]="false"> </dxi-column>
                    <dxi-column dataField="timeCategoryId" caption="Type" width="110" [allowEditing]="!readOnly">
                        <dxo-lookup [dataSource]="timeCategories" displayExpr="name" valueExpr="id"> </dxo-lookup>
                    </dxi-column>
                    <dxi-column dataField="description" [allowEditing]="false" width="150"></dxi-column>
                    <dxi-column dataField="note" [allowEditing]="!readOnly" width="150"></dxi-column>
                    <dxi-column dataField="quantity" [allowEditing]="true"></dxi-column>
                    <dxo-editing mode="row" [allowUpdating]="!readOnly" [allowDeleting]="!readOnly"></dxo-editing>

                    <dxo-summary>
                        <dxi-total-item column="quantity" summaryType="sum"> </dxi-total-item>
                    </dxo-summary>
                </dx-data-grid>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <div class="col-sm-2 m-0">
        <button type="button" class="btn btn-success" (click)="addEntry()" [hidden]="readOnly">Add</button>
        <!-- <button type="button" class="btn btn-danger" (click)="approve(true)" [hidden]="!readOnly">UnApprove</button> -->
    </div>
    <div class="col-sm-10 m-0 d-flex justify-content-end">
        <button type="button" class="btn btn-secondary" (click)="close()">Close</button>
    </div>
</div>
